module.exports = __webpack_public_path__ + "img/appraisal.bfdc1b7e.svg";